import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        className: {
            type: String,
            default: ''
        }
    },
    data: function () {
        var swiper = {};
        return {
            swiper: swiper
        };
    },
    mounted: function () {
        this.swiper = this.initCarousel(this.$swiper);
    },
    methods: {
        initCarousel: function (Swiper) {
            var options = {
                modules: [this.$swiperModules.Pagination, this.$swiperModules.Autoplay],
                slidesPerView: 1,
                allowTouchMove: true,
                loop: true,
                autoHeight: false,
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            };
            return new Swiper(this.$refs.swiper, options);
        },
        gotoSlide: function (index) {
            this.swiper.slideToLoop(index + 1);
        }
    }
});
